import { DEFAULT_COLORS } from '../contexts/BackgroundContext';
import { v4 as uuidv4 } from 'uuid';
import {
  TAppElkAttendeeRole,
  TAppElkAttendeeStatus,
  TAppElkBackgroundAnimation, TAppElkEventQuestion,
  TAppElkInvitee,
  TAppElkInviteStatus,
  TAppElkLocation,
  TAppElkMessage,
  TElkGetAlbumDetailsResponse
} from 'TProtocol/prototypes/events/messages';

declare const ELK_WEBAPP_URL: string;

export class IUEvent {
  constructor({
                isPreview,
                title,
                id,
                url,
                colors,
                animation,
                photoUrl,
                isHost,
                isCreate,
                isClone,
                isFromInspiration,
                isPlaceholderUrl,
                openInvite,
                description,
                modificationId,
                messageModificationId,
                publicGuestList,
                cancelledTimestamp,
                messages,
                messagesArePersonal,
                hostedBy,
                hostEmail,
                message,
                timeZone,
                remindersEnabled,
                aiGeneratedPhotoUrls,
                questions,
                existingAlbumId,
                albumDetails,
                prompt,

                // From option
                attendees,
                subtitle,
                location,
                date,
                startTime,
                endTime
              }: Partial<IUEvent> = {}) {
    const uuid = uuidv4();
    let urlToPut: string | undefined = undefined;
    if (url) {
      urlToPut = url;
    } else if (id) {
      urlToPut = `https://${ELK_WEBAPP_URL}/event/${id}`;
    } else {
      urlToPut = `https://${ELK_WEBAPP_URL}/event/${uuid}`;
    }
    this.isCreate = isCreate ?? true;
    this.isPreview = isPreview ?? true;
    this.isClone = isClone ?? false;
    this.isFromInspiration = isFromInspiration ?? false;
    this.isPlaceholderUrl = isPlaceholderUrl ?? true;
    this.title = title ?? '';
    this.id = id ?? uuid;
    this.url = urlToPut;
    this.colors = colors ?? DEFAULT_COLORS;
    this.animation = animation ?? TAppElkBackgroundAnimation.LIGHT_SOURCE;
    this.photoUrl = photoUrl;
    this.aiGeneratedPhotoUrls = aiGeneratedPhotoUrls;
    this.isHost = isHost ?? false;
    this.openInvite = openInvite ?? true;
    this.publicGuestList = publicGuestList ?? true;
    this.remindersEnabled = remindersEnabled ?? true;
    this.description = description ?? '';
    this.modificationId = modificationId ?? Date.now().toString();
    this.messageModificationId = messageModificationId ?? Date.now().toString();
    this.cancelledTimestamp = cancelledTimestamp;
    this.messages = messages ?? null;
    this.messagesArePersonal = messagesArePersonal ?? false;
    this.hostedBy = hostedBy ?? '';
    this.hostEmail = hostEmail;
    this.timeZone = timeZone ?? Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.message = message ?? '';
    this.questions = questions ?? [];
    this.existingAlbumId = existingAlbumId;
    this.albumDetails = albumDetails;
    this.prompt = prompt;
    this.attendees = attendees ?? [];
    this.subtitle = subtitle ?? '';
    this.location = location ?? new TAppElkLocation({ displayName: '' });
    this.date = date;
    this.startTime = startTime ?? 0;
    this.endTime = endTime ?? 0;
    this.errors = {};
  }

  isCreate: boolean;
  isPreview: boolean;
  isClone: boolean;
  isFromInspiration: boolean;
  isPlaceholderUrl: boolean;
  title: string;
  id: string;
  url: string;
  colors: IUEventColors;
  animation: TAppElkBackgroundAnimation;
  photoUrl?: string;
  aiGeneratedPhotoUrls?: string[];
  isHost: boolean;
  openInvite: boolean;
  publicGuestList: boolean;
  description: string;
  modificationId: string;
  messageModificationId: string;
  cancelledTimestamp?: number;
  messages: TAppElkMessage[] | null;
  messagesArePersonal: boolean;
  hostedBy: string;
  hostEmail?: string;
  message: string;
  timeZone: string;
  remindersEnabled: boolean;
  questions: TAppElkEventQuestion[];
  existingAlbumId?: string;
  albumDetails?: TElkGetAlbumDetailsResponse;
  prompt?: string;

  attendees: TAppElkInvitee[];
  subtitle: string;
  location: TAppElkLocation;
  date?: Date;
  startTime: number;
  endTime: number;
  errors: IUEventErrors;
}

export class IUEventErrors {
  invalidTitle?: boolean;
  invalidDatePair?: boolean;
  missingImage?: boolean;
  invalidLocation?: boolean;
}

export interface IUEventColors {
  primary: string;
  secondary: string;
  highlightText: string;
  text: string;
  buttonTextColor: string;
}

export const cloneEvent = (event: IUEvent): IUEvent => {
  const newEventId = uuidv4();

  const newEvent = new IUEvent({
    ...event,
    id: newEventId,
    isCreate: true,
    isClone: true,
    url: `https://${ELK_WEBAPP_URL}/event/${newEventId}`,
    startTime: 0,
    endTime: 0,
    modificationId: Date.now().toString(),
    messageModificationId: Date.now().toString(),
    cancelledTimestamp: undefined,
    messages: []
  });

  newEvent.attendees.forEach((attendee) => {
    attendee.inviteeId = uuidv4();
    if (attendee.role !== TAppElkAttendeeRole.ORGANIZER) {
      attendee.inviteStatus = TAppElkInviteStatus.PENDING;
      attendee.rsvpStatus = TAppElkAttendeeStatus.INVITED;
    }
    attendee.additionalGuestCount = 0;
  });

  return newEvent;
};

export const findResponseMessage = (event: IUEvent, inviteeId: string): TAppElkMessage | undefined => {
  if (event.messages === null) {
    return undefined;
  }
  for (const message of event.messages) {

  }
  return undefined;
}
